"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _core=require("@emotion/core");var _default=_core.css`
    html {
        box-sizing: border-box;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }
`;exports.default=_default;